'use client';
import type { UndecoratedUser } from '@witmetrics/utils';
import { formatUserName } from '@witmetrics/utils/strings';
import { API } from '@/api';
import type { NavigationKey, ShortcutKey } from '@/types';

export const classes = {
  wrapper: 'size-full bg-aurora-mesh dark:bg-aurora-mesh-dark',
  screen: 'flex size-full flex-col bg-white/[0.46] dark:bg-[#242032]/[0.56]',
  body: 'relative z-10 flex min-h-0 flex-1',
  content: 'flex-1 h-full overflow-auto',
};

export function getShortcut(e: KeyboardEvent): ShortcutKey | null {
  switch (e.key?.toLowerCase()) {
    case 's':
      return '\\S';
    case 'p':
      return '\\P';
    case 't':
      return '\\T';
    case 'o':
      return '\\O';
    case 'a':
      return '\\A';
    case 'c':
      return '\\C';
    default:
      return null;
  }
}

export function getNavigation(e: KeyboardEvent): NavigationKey | null {
  switch (e.key?.toLowerCase()) {
    case 'd':
      return '/D';
    case 't':
      return '/T';
    case 'c':
      return '/C';
    case 'p':
      return '/P';
    case 'o':
      return '/O';
    case 'f':
      return '/F';
    default:
      return null;
  }
}

export function isIgnoredKey(e: KeyboardEvent) {
  return ['Shift', '/', '\\'].includes(e.key);
}

export async function fetchPracticeData(practiceId: number) {
  const pagination = { page: 1, pageSize: 100 }; // TODO: Pagination
  const [practicePreferences, practiceUsers, practiceLabs] = await Promise.all([
    API.Practices.fetchPracticePreferences(practiceId),
    API.Practices.fetchPracticeUsers(practiceId, { filters: [], pagination }),
    API.Practices.fetchPracticeLabs(practiceId, { filters: [], pagination }),
  ]);
  return {
    practicePreferences,
    practiceUsers: practiceUsers.results,
    practiceLabs: practiceLabs.results,
  };
}

export async function fetchLabData(labId: number) {
  const pagination = { page: 1, pageSize: 100 }; // TODO: Pagination
  const [labPreferences, labUsers, labPractices] = await Promise.all([
    API.Labs.fetchLabPreferences(labId),
    API.Labs.fetchLabUsers(labId, { filters: [], pagination }),
    API.Labs.fetchLabPractices(labId, { filters: [], pagination }),
  ]);
  return {
    labPreferences,
    labUsers: labUsers.results,
    labPractices: labPractices.results,
  };
}

export function buildRollbarPerson(user?: UndecoratedUser) {
  if (!user) return {};
  return {
    userId: user.id,
    name: formatUserName(user),
    email: user.email,
  };
}
